// PlannerItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class PlannerItem extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      onChange: PropTypes.func,
      index: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      item: null,
      onChange: null,
      index: 0
    }
  }

  render () {
    const { item, index } = this.props

    return (
      <div className='planner-item'>{this._renderClient(item, index)}</div>
    )
  }

  /* Private function */
  _renderRowInner (object, bHasThumb, bHasExpand) {
    const imageUrl =
      object.imageUrl ||
      (object.user ? object.user.imageUrl : '/images/common/upload.png')
    return (
      <div className='inner'>
        {bHasThumb && (
          <div className='thumb'>
            <Avatar imageUrl={imageUrl} />
          </div>
        )}
        <div className='title'>{object.title}</div>
        {bHasExpand && (
          <IconButton
            icon={`report-accordion${object.expanded ? 'open' : 'close'}`}
            type='normal'
            size='small'
            canHover={false}
            className={`planner-iconbutton planner-${
              object.expanded ? 'collapse' : 'expand'
            }`}
            onClick={this._onToggleExpand.bind(this, object)}
          />
        )}
      </div>
    )
  }

  _onToggleExpand (object, ev) {
    ev.preventDefault()

    object.expanded = !object.expanded
    this.forceUpdate()

    if (this.props.onChange) {
      this.props.onChange(this.props.item.id)
    }
  }

  _renderClient (client, idx) {
    return (
      <div className='client' key={idx}>
        {this._renderRowInner(client, true, true)}
        {client.expanded && (
          <div className='client-cont'>
            {client.projects.map((project, idx) =>
              this._renderProject(project, idx)
            )}
          </div>
        )}
      </div>
    )
  }

  _renderProject (project, idx) {
    return (
      <div className='project' key={idx}>
        {this._renderRowInner(project, false, true)}
        {project.expanded && (
          <div className='project-cont'>
            {project.phases.map((phase, idx) => this._renderPhase(phase, idx))}
          </div>
        )}
      </div>
    )
  }

  _renderPhase (phase, idx) {
    if (phase.activities.length <= 0) {
      return null
    }

    if (!phase.title) {
      phase.title = `${IntlUtil.convertMessage('planner.planner.phaseLabel')} ${
        idx + 1
      }`
    }

    return (
      <div className='phase' key={idx}>
        {this._renderRowInner(phase, false, true)}
        {phase.expanded && (
          <div className='phase-cont'>
            {phase.activities.map((activity, idx) =>
              this._renderActivity(activity, idx)
            )}
          </div>
        )}
      </div>
    )
  }

  _renderActivity (activity, idx) {
    return (
      <div className='activity' key={idx}>
        {this._renderRowInner(activity, false, true)}
        {activity.expanded && (
          <div className='activity-cont'>
            {activity.tasks.map((task, idx) => this._renderTask(task, idx))}
          </div>
        )}
      </div>
    )
  }

  _renderTask (task, idx) {
    return (
      <div className='task' key={idx}>
        {this._renderRowInner(task, true, false)}
      </div>
    )
  }
}

export default PlannerItem
